// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { BaseIcon, type IconProps } from '../BaseIcon'

export default (props: IconProps): JSX.Element => (
  <BaseIcon {...sanitizeProps(props)}>
    <path
      fillRule="evenodd"
      d="M13 18a1 1 0 1 1-1-1 1 1 0 0 1 1 1Zm0-2h-2v-6h2Zm-8.38 4h14.76L12 5.2ZM21 22H3a1 1 0 0 1-.89-1.45l9-18a1 1 0 0 1 1.78 0l9 18A1 1 0 0 1 21 22Z"
    />
  </BaseIcon>
)
